<template>
    <div class="pb-5">
        <az-toolbar>
            <az-search id="ajuste-busca"
                       slot="simpleSearch"
                       ref="campoBuscaLicitacao"
                       :filter="filtrosAtivos"
                       @advanced-search="eventoBuscaAvancada"
                       @simple-search="eventoBuscaSimples"
                       @clear="eventoLimpar"
                       @remove-filter="eventoRemoverFiltro"
                       simple-search-placeholder="Informe o objeto, nº do processo, nº do edital ou responsável">

                <az-search-item slot="search-items">
                    <v-text-field v-model="filtrosInterno.objeto.value" label="Objeto"
                                  placeholder="Ex. Compra de material de expediente"></v-text-field>
                </az-search-item>

                <az-search-item slot="search-items">
                    <az-combo-enum-licitacao v-model="filtrosInterno.modalidade.value"
                                             :enum-object="modalidades"
                                             label="Modalidade"/>
                </az-search-item>

                <az-search-item slot="search-items">
                    <az-date-simple date-format="DD/MM/YYYY"
                                    v-model="filtrosInterno.dataAberturaInicial.value"
                                    label="Data de Abertura"
                                    name-date="Data de Abertura"
                    ></az-date-simple>
                </az-search-item>

                <az-search-item slot="search-items">
                    <v-text-field v-model="filtrosInterno.edital.value" label="Número do Edital"
                                  placeholder="Ex. 001/2020"></v-text-field>
                </az-search-item>

                <az-search-item slot="search-items">
                    <v-text-field v-model="filtrosInterno.processo.value" label="Número do Processo"
                                  placeholder="Ex. 000.001/2020"></v-text-field>
                </az-search-item>

                <az-search-item slot="search-items">
                    <v-text-field v-model="filtrosInterno.responsavel.value" label="Responsável"
                                  placeholder="Ex. Secretaria de Estado"></v-text-field>
                </az-search-item>
            </az-search>
        </az-toolbar>

        <consultas-listagem-tabela :itens="itens" :paginas="paginas" :total-itens="totalItens"
                                       :paginacao="$store.state.licitacaoBusca.paginacao"
                                       @paginar="eventoPaginar"
                                       @visualizar="eventoVisualizar"/>
        <az-dialog v-if="mostrarDialogErroMunicipio"
                   @ok="mostrarDialogErroMunicipio = false"
                   :width="450">
            <wrapper-dialog>
                <div class="dialog-erro">
                    <v-card-text class="dialog-title">Existem inconsistências no cadastro do órgão</v-card-text>
                    <span class="dialog-text">Senhor(a) Usuário(a) o município não foi informado no cadastro do seu órgão.</span><br/>
                    <span class="dialog-text">Por favor entre em contato através dos nossos telefones ou do chat disponíveis no portal comprasbr.com.br.</span>
                </div>
            </wrapper-dialog>
        </az-dialog>
    </div>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapMutations, mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import {statusLicitacao} from '@/commons/constants'
import {filtroOrgao, filtroStatusLicitacao} from '@/commons/filters'
import {filters} from '@azinformatica/loki'
import ComboOrgao from '@/commons/components/ComboOrgao.vue'
import WrapperDialog from '@/commons/components/WrapperDialog.vue'
import AzDateLicitacao from '@/commons/components/AzDateLicitacao.vue'
import AzComboEnumLicitacao from '@/commons/components/AzComboEnumLicitacao.vue'
import ConsultasListagemTabela from '@/views/consultas/listagem/components/tabela/ConsultasListagemTabela.vue'

export default {
    name: 'ConsultasListagem',
    components: {
        AzComboEnumLicitacao,
        AzDateLicitacao,
        ConsultasListagemTabela,
        ComboOrgao,
        WrapperDialog
    },
    data() {
        return {
            licitacaoStatus: statusLicitacao,
            licitacaoEsclarecimentoImpugnacao: {
                true: 'Sim',
                false: 'Não'
            },
            filtrosInterno: _.cloneDeep(this.$store.state.licitacaoBusca.filtros),
            itens: [],
            paginas: 0,
            totalItens: 0,
            mostrarDialogErroMunicipio: false,
            exibirBannerPlano: false,
            planoExpirado: null,
            orgaoLogado: null,
            comissoes: {},
            modalidades: {}
        }
    },
    computed: {
        ...mapState(['parametros']),
        filtrosAtivos() {
            const filtros = _.cloneDeep(this.$store.state.licitacaoBusca.filtros)
            const filtrosAtivos = {}
            for (let [chave, val] of Object.entries(filtros)) {
                if (filtros[chave].value) {
                    if (chave === 'status') {
                        val.value = filtroStatusLicitacao(val.value)
                    }
                    if (chave === 'idOrgao') {
                        val.value = filtroOrgao(val.value)
                    }
                    val.valueTruncated = filters.azClipText(val.value, 10)
                    filtrosAtivos[chave] = val
                }
            }
            return filtrosAtivos
        },
    },
    async mounted() {
        this.forcarExibirFiltrosAvancados()
        await this.acaoBuscarModalidades()
    },
    methods: {
        ...mapMutations([
            mutationTypes.LIMPAR_FILTROS_BUSCA_LICITACAO,
            mutationTypes.SET_FILTROS_BUSCA_LICITACAO,
            mutationTypes.SET_PAGINACAO_BUSCA_LICITACAO
        ]),
        ...mapActions([
            actionTypes.BUSCAR_MODALIDADES,
            actionTypes.BUSCAR_LICITACOES_LEGADO,
        ]),
        async acaoBuscarModalidades() {
            const response = await this.buscarModalidades()

            if (response != null && response.modalidades) {
                this.modalidades = response.modalidades.reduce((acc, item) => {
                    acc[item] = item
                    return acc
                }, {})
            }
        },
        async buscar() {
            try {
                this.$store.commit(mutationTypes.SET_FILTROS_BUSCA_LICITACAO, _.cloneDeep(this.filtrosInterno))
                this.setMensagemLoading('Carregando Licitações...')
                const resultado = await this.buscarLicitacoesLegado()
                this.itens = resultado.page.content
                this.paginas = resultado.page.totalPages
                this.totalItens = resultado.page.totalElements
            } catch (err) {
                const municipioException = 'br.com.azi.licitacao.licitacao.licitacao.exception.LicitacaoOrgaoSemMunicipioException'
                if (err.response && err.response.data.exception === municipioException) {
                    this.mostrarDialogErroMunicipio = true
                }
            }
        },
        eventoBuscaAvancada() {
            this.buscar()
        },
        eventoBuscaSimples(valor) {
            this.filtrosInterno.conteudo.value = valor
            this.buscar()
        },
        eventoLimpar() {
            this.$store.commit(mutationTypes.LIMPAR_FILTROS_BUSCA_LICITACAO)
            this.filtrosInterno = _.cloneDeep(this.$store.state.licitacaoBusca.filtros)
            this.buscar()
        },
        eventoPaginar(paginacao) {
            this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_LICITACAO, paginacao)
            this.buscar()
        },
        eventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.buscar()
        },
        eventoVisualizar(id) {
            const item = this.itens.find(item => item.id === id);
            this.eventoVisualizarConsultas(item)
        },
        eventoVisualizarConsultas(item) {
            this.$router.push({name: 'consultas', params: {id: item.id}})
        },
        forcarExibirFiltrosAvancados() {
            const componenteBusca = this.$refs.campoBuscaLicitacao
            componenteBusca.hasAdvancedSearchItems = true
        }
    }
}
</script>

<style lang="stylus">
#ajuste-busca > .simple-search > .input-search
    width: 410px !important;
    overflow hidden
</style>